import {TextareaVariable} from '../types'


// Adapter — turn our simple `TextareaVariable[]` into the shape that
// the shared `AddField` popover component expects.
//
// `AddField` is a generic "manage which columns are visible" UI; we
// reuse it as a "pick a variable to insert" UI. The popover takes a
// `manageColumnsConfig` array of categories (we use a single
// "Generic" category) and a `fields` array of items (one per variable).


export type AddFieldConfig = {
    manageColumnsConfig : Array<{value: string, label: string, type: string, items: AddFieldItem[]}>
    fields              : AddFieldItem[]
}

export type AddFieldItem = {
    fieldId : string    // the `{TOKEN}` literal — sent back as the row id when clicked
    label   : string
    icon    : string
}


export function textareaWithVariables_buildAddFieldConfig(tokens: TextareaVariable[]): AddFieldConfig {
    const items: AddFieldItem[] = _.map(tokens, t => ({
        fieldId : t.token,
        label   : t.label,
        icon    : t.icon,
    }))

    // Partition into ordered category groups. Each distinct `group`
    // label becomes one section in the Add-field popover, in the order
    // it first appears in `tokens`. Variables without a group fall into
    // a single "Generic" section.
    const order   : string[]                          = []
    const byGroup : {[label: string]: AddFieldItem[]} = {}
    _.forEach(tokens, (t, i) => {
        const label = t.group || 'Generic'
        if (!byGroup[label]) {
            byGroup[label] = []
            order.push(label)
        }
        byGroup[label].push(items[i])
    })

    const manageColumnsConfig = _.map(order, label => ({
        value : _.kebabCase(label) || 'generic',
        label : label,
        type  : 'system',
        items : byGroup[label],
    }))

    return {
        manageColumnsConfig,
        fields : items,
    }
}
